import { ModalOrderInfosChangeWarningTypeEnum } from '@/components/modal-order-infos-change-warning'
import {
  LogisticShipmentProps,
  OrderInvoiceProps,
  OrderPaymentProps,
  SaleOrderProps,
} from '@/types'

export const getFormattedDataToPayload = (
  data: SaleOrderProps,
): Partial<SaleOrderProps> => {
  return {
    uuid: data?.uuid,
    shipments: (data?.shipments?.map((shipment) => ({
      uuid: shipment.uuid,
      status: shipment.status,
      deliveredAt: shipment.deliveredAt || null,
      transportOptions: shipment.transportOptions || undefined,
      price: shipment.price || undefined,
      customsCost: shipment.customsCost || undefined,
      extraCost: shipment.extraCost || undefined,
      extraCostReason: shipment.extraCostReason || undefined,
      extraCostObservation: shipment.extraCostObservation || undefined,
      firstMileCost: shipment.firstMileCost || undefined,
      lastMileCost: shipment.lastMileCost || undefined,
      expectedDeliveryAt: shipment.expectedDeliveryAt || null,
      expectedDeliveryDays: shipment.expectedDeliveryDays || undefined,
      expectedDeliveryDate: shipment.expectedDeliveryDate || null,
    })) || []) as LogisticShipmentProps[],
    payments: (data?.payments?.map(({ uuid, status, paidAt }) => {
      return {
        uuid,
        status,
        paidAt,
      }
    }) || []) as OrderPaymentProps[],
    invoices: (data?.invoices?.map(({ uuid, status }) => {
      return {
        uuid,
        status,
      }
    }) || []) as OrderInvoiceProps[],
  }
}

export const getChangedTypes = (initialValues: SaleOrderProps, values: SaleOrderProps): (keyof typeof ModalOrderInfosChangeWarningTypeEnum)[] => {
  const changedFields: (keyof typeof ModalOrderInfosChangeWarningTypeEnum)[] = []

  const initialShipment = initialValues?.shipments?.[0]
  const currentShipment = values?.shipments?.[0]

  if (!initialShipment || !currentShipment) {
    return changedFields
  }

  const fieldMappings: Record<string, keyof typeof ModalOrderInfosChangeWarningTypeEnum> = {
    firstMileCost: 'order_shipment_first_mile_cost',
    lastMileCost: 'order_shipment_last_mile_cost',
    customsCost: 'order_shipment_customs_cost',
    extraCost: 'order_shipment_extra_cost',
    expectedDeliveryAt: 'order_shipment_expected_delivery_at',
  }

  const fieldsToCheck = [
    'firstMileCost',
    'lastMileCost',
    'customsCost',
    'extraCost',
    'expectedDeliveryAt',
  ] as const

  fieldsToCheck.forEach(field => {
    if (initialShipment[field] && initialShipment[field] !== currentShipment[field]) {
      changedFields.push(fieldMappings[field])
    }
  })

  return changedFields
}